module.exports = {"659004001":"军垦路街道","659004002":"青湖路街道","659004003":"人民路街道","659004100":"梧桐镇","659004101":"蔡家湖镇","659004500":"兵团一零一团","659004501":"五家渠经济技术开区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659004.json
// module id = 3296
// module chunks = 0